<template>
  <img :src="imageSrc" :alt="alt" :class="class" />
</template>

<script setup lang="ts">
import { convertSuitableImagePath } from '@/utils/ImageHelper';
const { isLargeScreen } = useDeviceCheck();

type Props = {
  src: string;
  alt: string;
  class: string;
};
const props = defineProps<Props>();

const imageSrc = ref<string>('');
watch(
  isLargeScreen,
  () => {
    if (isLargeScreen.value !== null) {
      imageSrc.value = convertSuitableImagePath(props.src, isLargeScreen.value);
    }
  },
  { immediate: true }
);
</script>
